export const navigationHiddenPartiallyUrls = [
  '/process-ai/process-discovery-new/',
];

export const mainWrapperWithoutPaddingUrls = [
  `/platform/apps/lighthouse-homepage/setup`,
];

export const navigationHiddenPartiallyPlusFooterUrls = [
  '/platform/apps/builder/configurations/', // eg: /platform/apps/builder/configurations/{uuid}
  '/platform/apps/com_zuora/chargesearch',
  '/platform/apps/meters/configure/', // eg: /platform/apps/meters/configure/{uuid}
  '/platform/apps/rules-engine/table',
  '/platform/apps/rules-engine/tree',
  '/platform/apps/rules-engine/flow',
  '/platform/apps/rules-engine/function',
  '/platform/apps/custom-logic/table',
  '/platform/apps/custom-logic/tree',
  '/platform/apps/custom-logic/flow',
  '/platform/apps/custom-logic/function',
  '/platform/apps/automation/builder', // eg: /platform/apps/automation/builder/{uuid}, /platform/apps/automation/builder/{uuid}/history
  '/services/workflow-staging/api_calls/',
  '/services/workflow/workflows/', // eg: /services/workflow/workflows/{id}
  '/services/workflow/api_calls/',
  '/platform/apps/zuora-ai',
  '/platform/apps/lighthouse-homepage/setup',
];

export const AIPanelHiddenUrls = [
  '/platform/apps/zuora-ai',
  '/platform/apps/lighthouse-homepage/setup',
];

export const AgentNames = {
  Orchestrator: 'orchestrator',
};

export type AgentName = typeof AgentNames[keyof typeof AgentNames];
export const NAV_WIDTH = '224px';
export const TOGGLE_CHEVRON_POSITION_OPENED = '212px';
export const TOGGLE_CHEVRON_POSITION_CLOSED = '10px';
export const BLANK_VALUE = '--';
